import './App.css';
import {MainHeader} from './Components/Header';
import { MainFooter } from './Components/Footer';
import {Home} from './Components/Home';
import { Route, Routes } from 'react-router-dom';
import { NavBar } from './Components/NavBar';
import { AboutUs, Page2, Page3, Page4 } from './Components/About';
import './Components/i18';
import LangChange from './Components/LangChange';
import Constitution from './Components/Constitution';

function App() {
  return (
    <div className="appMainDiv">
      <LangChange/>
      <MainHeader/>
      <NavBar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<AboutUs/>}/>
        <Route path='/constitution' element={<Constitution/>}/>
        <Route path='/page2' element={<Page2/>}/>
        <Route path='/page3' element={<Page3/>}/>        
        <Route path='/page4' element={<Page4/>}/>
      </Routes>
      <MainFooter/>
    </div>
  );
}

export default App;
